<template>
  <div class="main flex h-screen flex-col">
    <router-view class="flex-grow" />
    <Rodape class="bottom-0" />
  </div>
  <div id="modal"></div>
  <div id="modalNotification"></div>
  <a id="btnTop" class="bg-green-700 text-white" href="#" title="Ir para o Topo">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="h-6 w-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75" />
    </svg>
  </a>
</template>

<script lang="ts" setup>
import Rodape from './components/Rodape.vue';
import { onMounted } from 'vue';

// Verifica se é um redirecionamento após logout do Keycloak e precisa fazer logout no GOV.BR
onMounted(() => {
  // Logic moved to main.ts to execute before App mount
});

window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  const button = document.getElementById('btnTop');
  if (button) {
    button.style.display = document.body.scrollTop > 20 || document.documentElement.scrollTop > 20 ? 'block' : 'none';
  }
}
</script>

<style>
html {
  scroll-behavior: smooth;
}

.main {
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr auto;
}

#btnTop {
  display: none;
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 99;
  font-size: 18px;
  border: none;
  outline: none;
  color: white;
  cursor: pointer;
  padding: 15px;
  border-radius: 4px;
}

#btnTop:hover {
  background-color: #555;
}
</style>
